jQuery(document).ready(function ($) {
  // Initialize select2
  jQuery(".js-news-filter").select2({
    debug: true,
  });

  // Get the current sort option from the URL
  const urlParams = new URLSearchParams(window.location.search);
  const currentSortOption = urlParams.get("sortpost");

  // If there's a sortpost parameter in the URL, set the select box to that value
  if (currentSortOption) {
    jQuery("#sortpost").val(currentSortOption).trigger("change.select2");
  }

  // Handle the change event for the select box
  jQuery("#sortpost").on("change", function () {
    const sortValue = jQuery(this).val();
    const currentUrl = window.location.href.split("?")[0]; // Get current URL without query parameters
    window.location.href = `${currentUrl}?sortpost=${sortValue}`; // Redirect to the same page with the selected sort option
  });

  // Анимация для появления элементов
  jQuery(".news__item").each(function (index) {
    $(this)
      .delay(100 * index)
      .queue(function (next) {
        $(this).addClass("show"); // Добавляем класс с анимацией
        next();
      });
  });
});
